import {Menu} from "@headlessui/react";
import React from "react";
import {classNames} from "../../services/string";

type FloatingDropdownItemProps = {
  label: string
  onPress: () => void
}

function FloatingDropdownItem({label, onPress}: FloatingDropdownItemProps) {
  return (
    <Menu.Item>
      {({ active }) => (
        <button
          onClick={onPress}
          className={classNames(
            active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
            'block px-4 py-2 text-sm text-left w-full'
          )}
        >
          {label}
        </button>
      )}
    </Menu.Item>
  )
}

export default FloatingDropdownItem